import { render, staticRenderFns } from "./reportcards.vue?vue&type=template&id=c8e03bc8&"
import script from "./reportcards.vue?vue&type=script&lang=js&"
export * from "./reportcards.vue?vue&type=script&lang=js&"
import style0 from "./reportcards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports